/**
 * Utility functions for filtering financial categories
 */

/**
 * Filters categories to return only leaf nodes (categories without children)
 * Parent categories should not be used for direct financial entries
 */
export const getLeafCategories = <T extends { id: string; parent_category_id?: string | null }>(
  categories: T[]
): T[] => {
  // Create a set of all parent category IDs
  const parentIds = new Set(
    categories
      .map(cat => cat.parent_category_id)
      .filter((id): id is string => id !== null && id !== undefined)
  );
  
  // Return only categories that are not parents of any other category
  return categories.filter(cat => !parentIds.has(cat.id));
};
